export const lifecycleASuffixes = ['_A', '_A1-A3', '_A4', '_A5'] as const;
// B1.1/B1.2 are excluded since dots are invalid in mathjs unit aliases
export const lifecycleBSuffixes = [
  '_B',
  '_B1',
  '_B2',
  '_B4',
  '_B6',
  '_B7',
] as const;
// C3 and C4 are combined into one module per IVL, so only `_C3-C4` is registered
export const lifecycleCSuffixes = ['_C', '_C1', '_C2', '_C3-C4'] as const;
export const lifecycleSuffixes = [
  ...lifecycleASuffixes,
  ...lifecycleBSuffixes,
  ...lifecycleCSuffixes,
] as const;
export type LifeCycleSuffixes = (typeof lifecycleSuffixes)[number];

export const expandWithLifecycleSuffixes = <const T extends string>(
  base: T,
): `${T}${LifeCycleSuffixes}`[] => {
  return lifecycleSuffixes.map((suffix) => `${base}${suffix}` as const);
};
